import styled, { css } from 'styled-components';
import { Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  ${Mixins.Media.maxWidthMedium(css`
    margin-top: ${Spacing.DOUBLE_HALF};
  `)}
`;

export const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${Spacing.SINGLE_HALF} ${Spacing.SINGLE};
  font-family: ${Font.Family.SANS};
  color: ${Colors.GRAY_DARK_30};
`;
